export const getTextColor = (color: string) => {
  const [red, green, blue] = hexToRGB(color);
  if (red * 0.299 + green * 0.587 + blue * 0.114 > 190) {
    return '#000000';
  }
  return '#ffffff';
};

const hexToRGB = (hex: string): [number, number, number] => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return [r, g, b];
};



// WEBPACK FOOTER //
// ./src/utils/colors.ts